/**
 * Функция для подсчета общего количества страниц.
 *
 * @param totalElements {number} - Общее количество элементов.
 * @param pageSize {number} - Количество элементов, отображаемых на страницу.
 * @returns {number} - Общее количество страниц.
 */
export const getTotalPages = (totalElements: number, pageSize: number) =>
  Math.ceil(totalElements / pageSize);
